<template>
  <div class="box">
    <img src="@/assets/image/success.png" alt="" srcset="" />
    <div class="text1">发送成功</div>
    <div class="text2">
      申请信息以手机短信的方式已发送，可联系

      <span class="span1"> {{ chaxunData.name }} </span>
      <span class="span2"> 法人（{{chaxunData.representativeName}} {{chaxunData.representativePhone}}）</span>
      确认
    </div>
    <el-button class="button" type="primary" @click="tohome">返回首页</el-button>
  </div>
</template>

<script>
import mixins from "./mixins";
export default {
  mixins: [mixins],
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    tohome() {
      this.$router.push({ path: "/" });
      this.hideMode2()
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  img {
    width: 48px;
    height: 48px;
    margin-top: 309px;
  }
  .text1 {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0px;

    font-variation-settings: "opsz" auto;
    color: #1d2129;

    margin-top: 16px;
  }
  .text2 {
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    letter-spacing: 0px;

    font-variation-settings: "opsz" auto;
    z-index: 0;
    /* 申请信息以手机短信的方式已发送，可联系 */
    color: #666666;
    .span1 {
      color: #262626;
    }
    .span2 {
      color: #0062ff;
    }
  }
  .button {
    margin-top: 16px;
    @include buttonStyle2;
  }
}
</style>
